import { useNavigate } from "react-router";
import { toast } from "sonner";

import { type DossierStatusId, StatusBadge } from "../../status";

interface TeamRow {
  ref: string;
  researcher: string;
  project: string;
  submitted: string;
  status: DossierStatusId;
}

const ROWS: TeamRow[] = [
  {
    ref: "EA-2026-041",
    researcher: "Els Vermeersch",
    project: "Social Media & Body Image bij jongeren (kwalitatief onderzoek)",
    submitted: "22 jun 2026",
    status: "revisie-gevraagd",
  },
  {
    ref: "EA-2026-033",
    researcher: "Thomas Mertens",
    project: "Cross-cultureel onderzoek naar motivationele communicatie",
    submitted: "8 jun 2026",
    status: "goedgekeurd",
  },
  {
    ref: "EA-2026-021",
    researcher: "Sara Lemmens",
    project: "Focusgroep over voedingsgedrag bij adolescenten",
    submitted: "5 mei 2026",
    status: "goedgekeurd",
  },
  {
    ref: "EA-2026-018",
    researcher: "Mohammed El Haddad",
    project: "Survey over digitale geletterdheid en sociale media",
    submitted: "22 apr 2026",
    status: "goedgekeurd",
  },
];

export function TeamAanvragenPage() {
  const navigate = useNavigate();

  const openDossier = (row: TeamRow) => {
    if (row.status === "goedgekeurd") {
      toast("Out of Scope", {
        description: "Goedgekeurde dossiers zijn buiten scope voor deze demo.",
      });
      return;
    }
    void navigate(`/dashboard/aanvraag-detail?dossierId=${row.ref}`);
  };

  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Aanvragen van mijn onderzoekers</h1>
          <p>
            Prof. dr. Koen Willems · Faculteit OHW · 4 actieve dossiers
            <span className="badge badge--info" style={{ marginLeft: "10px" }}>
              Alleen-lezen
            </span>
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card__head">
          <h2>Overzicht dossiers</h2>
          <span className="ua-muted-sm">
            Alleen-lezen: acties zijn voorbehouden aan de onderzoeker
          </span>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Ref.</th>
              <th>Onderzoeker</th>
              <th>Project</th>
              <th>Ingediend</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.ref} style={{ cursor: "pointer" }} onClick={() => openDossier(row)}>
                <td className="ua-muted-xs">{row.ref}</td>
                <td>{row.researcher}</td>
                <td style={{ fontSize: "13px", maxWidth: "260px" }}>{row.project}</td>
                <td className="ua-muted-xs">{row.submitted}</td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <a
                    href="#"
                    className="text-[13px]"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      openDossier(row);
                    }}
                  >
                    Bekijk
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card" style={{ marginTop: "var(--ua-space)" }}>
        <div className="card__head">
          <h2>Uw rol als promotor</h2>
        </div>
        <div className="card__body">
          <ul className="ua-col-sm-tight">
            <li className="control-item">
              <span className="control-icon control-icon--human">P</span>
              <div>
                <div className="ua-bold-sm">Inzagrecht</div>
                <div className="ua-muted-xs">
                  U kunt alle dossiers van uw onderzoekers inzien, inclusief AI-feedback en
                  beslissingen.
                </div>
              </div>
            </li>
            <li className="control-item control-item--muted">
              <span className="control-icon control-icon--ai">i</span>
              <div>
                <div className="ua-bold-sm">Geen bewerkingsrecht</div>
                <div className="ua-muted-xs">
                  Aanpassen en indienen is voorbehouden aan de onderzoeker zelf. Neem rechtstreeks
                  contact op.
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
